import { render, staticRenderFns } from "./newCoupons.vue?vue&type=template&id=6e77348e&scoped=true&"
import script from "./newCoupons.vue?vue&type=script&lang=js&"
export * from "./newCoupons.vue?vue&type=script&lang=js&"
import style0 from "./newCoupons.vue?vue&type=style&index=0&id=6e77348e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e77348e",
  null
  
)

export default component.exports